export default __webpack_public_path__ + "static/media/yellowArrowUpLow.be1e3d53.svg";